import { render } from "./DetailProperties.vue?vue&type=template&id=881cd91e"
import script from "./DetailProperties.vue?vue&type=script&lang=js"
export * from "./DetailProperties.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__